import React, { createContext, useContext, useState } from 'react';
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const { trackEvent } = useGoogleAnalytics();

  const openBooking = (source = 'unknown') => {
    setIsBookingOpen(true);
    trackEvent('booking_modal_toggle', {
      action: 'open',
      location: source
    });
  };

  const closeBooking = () => {
    setIsBookingOpen(false);
  };

  return (
    <BookingContext.Provider value={{ isBookingOpen, openBooking, closeBooking }}>
      {children}
    </BookingContext.Provider>
  );
};
